/** Shared Redux key for the AI image/sticker prompt box — one draft across every host (left toolbar, stock popup, mobile modal). */
export const AI_IMAGE_PROMPT_BOX_ID = 'toolbar-ai-generate-image-prompt-box';
